import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import HelpContentLayout from './HelpContentLayout';
import HelpContentBlock from './HelpContentBlock';

export default function ReferralsHelpContent({ close }) {
  const { t } = useTranslation();
  const { statistic } = useSelector((state) => state.referrals);
  const list = [
    { img: 'cheese', text: t('referral_help_share') },
    { img: 'handshake', text: t('referral_help_sign_up') },
    {
      img: 'money',
      text: t('referral_help_income', { rate: statistic?.rate ?? 0 }),
    },
  ];

  return (
    <HelpContentLayout close={close}>
      <div className="helpContent">
        {list.map((item) => (
          <HelpContentBlock key={item.img} img={item.img} text={item.text} />
        ))}
      </div>
    </HelpContentLayout>
  );
}
